module.exports = __webpack_public_path__ + "static/passionfruit-1288edbb4a75105a12b15f7543e5d411.png";